/* eslint-disable max-len */
import React from "react";
import AvatarCustom from "../AvatarCustom/AvatarCustom";
import { modalStorageKeys, WELLNESS_PLAN_STATUSES, WellnessRenewalReminderType } from "../../config/params";

interface IWellnessReminderCard {
  planOverdueStatus: string;
  petName: string;
  planEndDate: string;
  reminderType: WellnessRenewalReminderType | "paymentOverdueAlert";
  petImage?: string;
  cardLastFourDigits?: string;
  planName?: string;
}

const WellnessReminderCard = ({
  planOverdueStatus,
  petName,
  petImage,
  reminderType,
  planName,
}: IWellnessReminderCard) => {
  const petNameCapitalization = (name: string) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getReminderCardDescription = () => {
    switch (reminderType) {
    case modalStorageKeys.nonAutoRenewEndedPlans:
      return "You're now eligible to join the TotalCare wellness plan. With plans starting at less than $1 a day, we have a range of plans to fit your care and financial needs.";
    case modalStorageKeys.wellnessPlansEndingSoon:
      return `${planName ?? "Your plan"} will not renew at the end of your term.`;
    case modalStorageKeys.autoRenewEndedPlans:
      return "Your plan renewal failed due to an unpaid balance. Pay now to reactivate your plan.";
    case "paymentOverdueAlert":
      return "Your balance is overdue. Pay now to restore appointment booking and plan benefits.";
    case modalStorageKeys.autoRenewUnsuccessfulEndedPlans:
      return `We were unable to renew ${petNameCapitalization(petName)}'s plan. To take advantage of unlimited exams, discounts on services, and coverage for routine preventative care, purchase a new plan.`;
    default:
      return `Check out ${petNameCapitalization(petName)}'s GoodPet+ plan for latest updates`;
    }
  };

  return (
    <div className="rounded-lg p-4 bg-white">
      <div className="flex gap-4 w-full items-start">
        <div>
          <AvatarCustom
            width={64}
            height={64}
            image={petImage}
            name={petName}
            isWellnessMember={planOverdueStatus === WELLNESS_PLAN_STATUSES.ACTIVE}
            isPlanOverdue={planOverdueStatus !== WELLNESS_PLAN_STATUSES.ACTIVE}
          />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-xl mb-1">
            <p>
              {`${petNameCapitalization(petName)}'s Plan`}
            </p>
          </div>
          <div className="text-base leading-6">
            {getReminderCardDescription()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellnessReminderCard;
